import React, { useState } from 'react';
import {
  Row, Col, Input, Select
} from 'antd';
import { useTranslation } from 'react-i18next'; 
import { ResponsiveContainer } from 'recharts';
import withAuth from '@common/hocs/withAuth';
import MainLayout from '@common/layouts/MainLayout';
 
import useDashboardGeneral from './useDashboardGeneral';
import styles from './DashboardGeneral.module.less'

import DashboardRoot from './containers/DashboardRoot'; 
import DashboardAdmin from './containers/DashboardAdmin';
import DashboardVisitante from './containers/DashboardVisitante/DashboardVisitante';

const { Search } = Input;
const { Option, OptGroup } = Select;

const style = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: 25,
  marginTop: 25,
  cursor: 'pointer',
};

function DashboardGeneral() {

  const { t } = useTranslation();
  const {
    rol
  } = useDashboardGeneral();
 

  return (
    <MainLayout applyWidthLimit>
      <ResponsiveContainer> 
        <div className={styles.wrapper}>
          <div className={styles.fields_wrapper} />

          <DashboardAdmin />

          {/*rol=='Root' && <DashboardRoot /> */}
          {/*rol=='Visitante' && <DashboardVisitante /> */} 
           

        </div>
      </ResponsiveContainer>
    </MainLayout>
  );

}

export default withAuth(DashboardGeneral);
